export const dataDescricao = (cDataMensagem) => {
  const formatarData = (dData) => {
    return new Date(dData.getFullYear(), dData.getMonth(), dData.getDate())
  }

  const dDataMensagem = formatarData(new Date(cDataMensagem))
  const dDataAtual = formatarData(new Date())
  let dDataOntem = formatarData(new Date())
  dDataOntem.setDate(dDataAtual.getDate() - 1)

  const mDiasSemana = [
    "Domingo",
    "Segunda-feira",
    "Terça-feira",
    "Quarta-feira",
    "Quinta-feira",
    "Sexta-feira",
    "Sábado",
  ]

  if (dDataMensagem.getTime() === dDataAtual.getTime()) {
    return "Hoje"
  }

  if (dDataMensagem.getTime() === dDataOntem.getTime()) {
    return "Ontem"
  }

  const nDias = (dDataAtual.getTime() - dDataMensagem.getTime()) / (1000 * 60 * 60 * 24)
  if (nDias >= 2 && nDias <= 6) {
    return mDiasSemana[dDataMensagem.getDay()]
  }

  const cDataRetorno = `${dDataMensagem.getDate().toString().padStart(2, "0")}/${(dDataMensagem.getMonth() + 1)
    .toString()
    .padStart(2, "0")}/${dDataMensagem.getFullYear()}`
  return cDataRetorno
}
